
import Component from 'vue-class-component';
import Vue from 'vue';
import { namespace } from 'vuex-class';
import PageLoader from '@/core/components/PageLoader.vue';
import PageError from '@/core/components/PageError.vue';
import { Loan } from '@/loan/types/loan';
import LoanTopbar from '@/loan/components/LoanTopbar.vue';
import LoanMobileNav from '@/loan/components/LoanMobileNav.vue';
import LoanNav from '@/loan/components/LoanNav.vue';

const loanNamespace = namespace('loan');

@Component({
	components: {
		LoanMobileNav,
		LoanNav,
		PageLoader,
		LoanTopbar,
		PageError,
	},
})
export default class LoanLayout extends Vue {
	@loanNamespace.State('isPageLoaderShown')
	public isPageLoaderShown!: boolean;

	@loanNamespace.State('isPageErrorShown')
	public isPageErrorShown!: boolean;

	@loanNamespace.State('loan')
	public loan!: Loan;

	get logo(): string {
		return this.loan?.fiConfig?.logoFullUrl ?? '';
	}
}

